export function apiErrorMessage(data: unknown): string | undefined {
  if (typeof data === 'string') {
    const message = data.trim()
    return message && !message.startsWith('<') ? message : undefined
  }
  if (!data || typeof data !== 'object') return undefined
  const problem = data as Record<string, unknown>
  if (problem.errors && typeof problem.errors === 'object') {
    const messages = Object.values(problem.errors)
      .flat()
      .filter((value): value is string => typeof value === 'string' && !!value.trim())
    if (messages.length) return messages.join('\n')
  }
  for (const key of ['detail', 'message', 'title']) {
    const value = problem[key]
    if (typeof value === 'string' && value.trim()) return value
  }
  return undefined
}
